<template>
    <ShopFilterItem :title="title">
        <div class="flex justify-between text-xs text-secondary-500 mb-2">
            <span>${{ model[0] }}</span>
            <span>${{ model[1] }}</span>
        </div>

        <SliderRoot :min="min" :max="max" :default-value="[model[0], model[1]]" class="relative flex items-center" @value-commit="update">
            <SliderTrack class="relative flex-grow bg-primary-500 h-1">
                <SliderRange class="absolute bg-primary-100 inset-y-0" />
            </SliderTrack>

            <SliderThumb class="block w-4 h-4 bg-white border-[2px] border-primary-500 rounded-full" />
            <SliderThumb class="block w-4 h-4 bg-white border-[2px] border-primary-500 rounded-full" />
        </SliderRoot>
    </ShopFilterItem>
</template>

<script setup>
import {
    SliderRange, SliderRoot, SliderThumb, SliderTrack,
} from 'reka-ui';
import ShopFilterItem from './ShopFilterItem.vue';

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    min: {
        type: Number,
        required: true,
    },
    max: {
        type: Number,
        required: true,
    },
});

const model = defineModel({
    type: Array,
    required: true,
});

function update(newValue) {
    model.value = newValue;
}
</script>
